module.exports = __webpack_public_path__ + "img/check.33299198.svg";